module.exports = __webpack_public_path__ + "img/icon-snel-verkocht.a0cb49cb5c9a3f29cc134519a26c91d0.svg";